import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import PropertyShowcase from "@/components/PropertyShowcase";
import BlockchainSection from "@/components/BlockchainSection";
import AboutSection from "@/components/AboutSection";
import PricingSection from "@/components/PricingSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQContactSection from "@/components/FAQContactSection";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";

const LandingPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const { user } = useAuth();
  const navigate = useNavigate();

  const openAuthModal = (mode = "login") => {
    if (user) {
      navigate("/dashboard");
    } else {
      setAuthMode(mode);
      setAuthModalOpen(true);
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header onAuthClick={openAuthModal} />
      <main>
        <HeroSection onGetStarted={() => openAuthModal("register")} />
        <PropertyShowcase />
        <BlockchainSection />
        <AboutSection />
        <PricingSection onSelectPlan={() => openAuthModal("register")} />
        <TestimonialsSection />
        <FAQContactSection />
      </main>
      <Footer />
      <AuthModal 
        open={authModalOpen} 
        onOpenChange={setAuthModalOpen}
        mode={authMode}
        setMode={setAuthMode}
      />
    </div>
  );
};

export default LandingPage;
